<template>
  <div class="telemetry-gauge">
    <div class="dashboard-wrap">
      <div class="dashboard-table__container">
        <table class="dashboard-table">
          <tr>
            <td class="key-column">类别</td>

            <td
              v-for="(cate, index) in dataset.category"
              :key="index"
              :class="{ actived: actived === index }"
              class="dashboard-item"
              @click="setActived(index)"
            >
              <div class="cell">
                {{ cate }}
              </div>
            </td>
          </tr>

          <tr>
            <td class="key-column">预警级别</td>

            <td
              v-for="(figure, index) in dataset.figure"
              :key="index"
              :class="{ actived: actived === index }"
              class="dashboard-item"
              @click="setActived(index)"
            >
              <div class="cell">
                <echart
                  :height="40"
                  :width="80"
                  :chartId="`warning-${index}`"
                  :options="options(figure)"
                >
                </echart>
              </div>
            </td>
          </tr>

          <tr>
            <td class="key-column">今日总数</td>
            <td
              v-for="(today, index) in dataset.today"
              :key="index"
              :class="{ actived: actived === index }"
              class="dashboard-item"
              @click="setActived(index)"
            >
              <div class="cell">
                {{ today }}
              </div>
            </td>
          </tr>

          <tr>
            <td class="key-column">昨日总数</td>
            <td
              v-for="(yesterday, index) in dataset.yesterday"
              :key="index"
              :class="{ actived: actived === index }"
              class="dashboard-item"
              @click="setActived(index)"
            >
              <div class="cell">
                {{ yesterday }}
              </div>
            </td>
          </tr>

          <tr>
            <td class="key-column">
              发生量级别
              <div style="font-size: 12px;color: #909399;">
                (未来一周预测)
              </div>
            </td>
            <td
              v-for="(volume, index) in dataset.volume"
              :key="index"
              :class="{ actived: actived === index }"
              class="dashboard-item"
              @click="setActived(index)"
            >
              <div class="cell">
                <span :style="getVolumeStyle(volume)">
                  {{ getVolume(volume) }}
                </span>
              </div>
            </td>
          </tr>
        </table>
      </div>

      <slot></slot>
    </div>
  </div>
</template>

<script>
import Echart from '@/components/Chart'

const COLS = ['category', 'figure', 'today', 'yesterday', 'volume']

export default {
  components: { Echart },
  props: {
    deviceId: [Number, String],
    warnings: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      actived: null
    }
  },
  computed: {
    dataset() {
      let data = {}
      const device = this.warnings.filter(d => d.deviceId === +this.deviceId)

      COLS.forEach(col => (data[col] = device.map(d => d[col])))
      return data
    }
  },
  methods: {
    gaugeColors(value) {
      if (value < 35) return '#13ce66'
      else if (value < 60) return '#e6d23c'
      else if (value < 80) return '#e66e3c'
      else if (value >= 80) return '#ff4949'
    },
    getVolume(v) {
      switch (v) {
        case 0:
          return '不发生'
        case 1:
          return '微发生'
        case 2:
          return '轻发生'
        case 3:
          return '中发生'
        case 4:
          return '高发生'
        case 5:
          return '重发生'
        default:
          return '不发生'
      }
    },
    getVolumeStyle(v) {
      switch (v) {
        case 0:
          return { color: '#13ce66' }
        case 1:
          return { color: '#13ce66' }
        case 2:
          return { color: '#13ce66' }
        case 3:
          return { color: '#e6d23c' }
        case 4:
          return { color: '#e66e3c' }
        case 5:
          return { color: '#ff4949' }
        default:
          return { color: '#13ce66' }
      }
    },
    options(value) {
      const color = this.gaugeColors(value)
      let text = ''
      if (value < 35) {
        text = '低'
      } else if (value < 60) {
        text = '中'
      } else if (value < 80) {
        text = '高'
      } else {
        text = '重'
      }

      return {
        title: {
          text,
          left: '50%',
          top: '70%',
          padding: 0,
          textAlign: 'center',
          textStyle: {
            fontWeight: 400,
            fontSize: 14,
            color
          }
        },
        grid: {
          show: false,
          containLabel: false,
          left: 0,
          top: 0,
          right: 0,
          bottom: 0
        },
        tooltip: { show: false },
        xAxis: { show: false },
        yAxis: { show: false },
        legend: { show: false },
        toolbox: { show: false },
        series: [
          {
            type: 'pie',
            center: ['50%', '98%'],
            radius: ['100%', '190%'],
            startAngle: 180,
            itemStyle: {
              borderColor: 'rgb(215, 215, 215)'
            },
            color: [this.gaugeColors(value), '#D8D8D8', 'transparent'],
            silent: true,
            labelLine: { show: false },
            data: [
              value,
              100 - value,
              {
                value: 100,
                itemStyle: {
                  borderWidth: 0
                }
              }
            ]
          }
        ]
      }
    },
    setActived(i) {
      if (i !== this.actived) {
        this.actived = i
        const device = this.warnings.filter(d => d.deviceId === +this.deviceId)
        this.$emit('active-insect', device && device[i] && device[i].category)
      } else {
        this.actived = null
        this.$emit('active-insect')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.telemetry-gauge {
  height: 240px;
  background: #fff;
  .dashboard-wrap {
    // border: 1px solid #96c850;
    border-top: none;
    overflow-x: auto;
  }
  .dashboard-table__container {
    padding: 0 2rem;
    overflow: auto;
  }
  .dashboard-table {
    width: 100%;
    text-align: center;
    border-collapse: collapse;
    .key-column {
      font-size: 14px;
      color: #454545;
      word-break: keep-all;
      text-align: left;
      width: 6rem;
    }
    tr:nth-child(2) {
      td {
        padding-bottom: 0.5rem !important;
      }
    }
  }
  .dashboard-item .cell {
    font-size: 14px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
  }
  td {
    padding: 8px !important;
    line-height: 1.5rem;
    cursor: pointer;
    &.actived {
      background-color: #f5f7fa;
    }
  }
}
</style>
